mutation UpdateCampaignSection($sectionId: ID!, $name: String!) {
    updateCampaignSection(sectionId: $sectionId, name: $name) {
        _id
    }
}
